import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { ExternalLink, AlertCircle } from 'lucide-react';
import { useTestClock } from '@/contexts/TestClockContext';

export const CheckoutSettings = () => {
  const { openCheckoutInNewTab, setOpenCheckoutInNewTab } = useTestClock();

  return (
    <Card className="glass-card-strong hover-lift transition-all">
      <CardHeader>
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-full bg-gradient-to-r from-indigo-500/10 to-purple-500/10 flex items-center justify-center animate-float">
            <ExternalLink className="h-5 w-5 text-primary" />
          </div>
          <div>
            <CardTitle className="text-gradient">Checkout Behavior</CardTitle>
            <CardDescription>
              Control how Stripe checkout sessions are opened
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between p-4 rounded-lg border bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-950 dark:to-emerald-950">
          <div className="flex-1">
            <h3 className="text-sm font-semibold mb-1">Open Checkout in New Tab</h3>
            <p className="text-xs text-muted-foreground">
              {openCheckoutInNewTab 
                ? "Checkout sessions will open in a new tab" 
                : "Checkout sessions will redirect in the same tab"}
            </p>
          </div>
          <Switch
            checked={openCheckoutInNewTab}
            onCheckedChange={setOpenCheckoutInNewTab}
            className="data-[state=checked]:bg-green-600"
          />
        </div>

        <Alert>
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Global Setting</AlertTitle>
          <AlertDescription>
            This setting affects all Stripe checkout redirects including subscriptions and top-ups.
            When enabled, the current tab stays open while checkout opens in a new tab.
          </AlertDescription>
        </Alert>
      </CardContent>
    </Card>
  );
};
